import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useData } from '../context/DataContext';
import { AdminSidebar } from './admin/AdminSidebar';
import { AdminHeader } from './admin/AdminHeader';

export const AdminLayout: React.FC = () => {
  const { isAdmin, logout, publish, isDirty } = useData();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isAdmin) {
      navigate('/admin/login');
    }
  }, [isAdmin, navigate]);

  if (!isAdmin) return null;

  return (
    <div className="min-h-screen bg-[#020617] text-slate-300 flex selection:bg-[#14B8A6]/30" style={{ fontFamily: 'var(--font-body)' }}>
      <AdminSidebar logout={logout} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden bg-[#020617]">
        <AdminHeader isDirty={isDirty} publish={publish} />

        <main className="flex-1 overflow-auto p-12 custom-scrollbar">
          <div className="max-w-6xl mx-auto animate-in fade-in duration-1000">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};